import type { JsonCustomConvert } from 'json2typescript'
import type { PaymentTypeEnum } from '@/services/enums/DLDCommonValuesEnum'
import { JsonConverter } from 'json2typescript'

@JsonConverter
export default class PaymentTypeEnumConverter implements JsonCustomConvert<PaymentTypeEnum> {
  serialize(type: PaymentTypeEnum): string {
    return type.toString()
  }

  deserialize(type: string): PaymentTypeEnum {
    return type as PaymentTypeEnum
  }
}
